import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { dedupePropertyImages } from '~/services/AccommodationService';

export function useDedupePropertyImages() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ propertyId }: { propertyId: string }) => {
      const response = await dedupePropertyImages({ propertyId });
      return response;
    },
    onSuccess: () => {
      enqueueSnackbar('Image dedupe started', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to dedupe images: ${error.message}`, { variant: 'error' });
    },
  });
}
